module.exports = __webpack_public_path__ + "static/media/stress-management-large@2x.aaf45a88.png";